import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Sparkles } from 'lucide-react';
import { buildRoute } from '../../routes/routeConfig';

export const AdManagerPageActions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => navigate(buildRoute.adManagerAIWizard())}
        className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg bg-gradient-to-r from-primary-600 to-purple-600 text-white hover:from-primary-700 hover:to-purple-700 shadow-sm shadow-primary-500/25 transition-all"
      >
        <Sparkles className="w-4 h-4" />
        AI Wizard
      </button>
      <button
        onClick={() => navigate(buildRoute.adManagerCampaignCreate())}
        className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-colors"
      >
        <Plus className="w-4 h-4" />
        Create Campaign
      </button>
    </div>
  );
};

export default AdManagerPageActions;